import { IRegister } from "@/@types/Register";
import { api } from "./api";
import { IAuthResponse } from "@/auth/types";

async function register(data: IRegister,  referralCode?: string): Promise<IAuthResponse> {
  const headers: Record<string, string> = {};
  if (referralCode) {
    headers['X-Referrer-Code'] = referralCode;
  }

  const response = await api.post('/v1/authentication/register', {
    ...data,
    email: data.email?.trim().toLowerCase(),
  }, {
    headers,
  });

  return response.data;
}

export const RegisterService = { register };
